import { Outlet } from "react-router-dom";
import Navbar from "./navBar";
import NotificationListener from "./NotificationListener";
import { useUser } from "../contexts/UserProvider";

const Layout = () => {
    const { authUser } = useUser(); // We will get the user's uid

    return (
        <div style={{ height: "100vh", width: "100vw", display: "flex", flexDirection: "column" }}>
            {/* Listening to notifications in the background */}
            {authUser && <NotificationListener currentUserId={authUser.uid} />}

            <div style={{ height: "7%", width: "100%" }}>
                <Navbar />
            </div>
            <div style={{ height: "93%", width: "100%" }}>
                <Outlet />
            </div>
        </div>
    );
};

export default Layout;
